<!--
    描述：抽取结果
    日期：2022/9/19
    创建人：李家宝
-->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="抽 取 结 果" name="1">
        <!--抽取规则-->
        <el-empty description="暂 无 数 据" v-if="isEmpty"></el-empty>
        <template v-else>
          <div class="zjxq_box" v-if="reviewType == '1009007002'">
            <div class="box_text">抽取规则</div>
            <el-table
              class="mt10"
              highlight-current-row
              row-key="id"
              border
              ref="table"
              :data="extractDetailObj"
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="id"
                label="抽取规则ID"
                align="center"
                min-width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="conditionName"
                label="抽取条件"
                align="center"
                min-width="200"
                show-overflow-tooltip
              >
              </el-table-column>
              <!--<el-table-column-->
              <!--  prop="speName"-->
              <!--  label="专业"-->
              <!--  align="center"-->
              <!--  min-width="180"-->
              <!--  show-overflow-tooltip-->
              <!--&gt;-->
              <!--</el-table-column>-->
              <el-table-column
                prop="persons"
                label="计划人数"
                align="center"
                min-width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="realNums"
                label="搜索匹配人数"
                align="center"
                min-width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="operator"
                label="操作人"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="操作时间"
                align="center"
                min-width="180"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="zjxq_box">
            <div class="box_text">抽取结果</div>
            <el-table
              class="mt10"
              highlight-current-row
              row-key="id"
              border
              ref="table"
              :data="rowData"
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="sname"
                align="center"
                label="专家姓名"
                min-width="130"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="randomCode"
                align="center"
                label="专家随机码"
                min-width="130"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.randomCode == "" ? "--" : scope.row.randomCode }}
                </template>
              </el-table-column>
              <el-table-column
                prop="phone"
                align="center"
                label="手机号"
                min-width="130"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="sex"
                align="center"
                label="性别"
                min-width="130"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.sex == 0 ? "女" : "男" }}
                </template>
              </el-table-column>
              <el-table-column
                v-if="reviewType == '1009007002'"
                prop="age"
                align="center"
                label="年龄"
                width="80"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="certificateGrade"
                align="center"
                label="职称"
                min-width="130"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="type"
                align="center"
                label="执业资格"
                min-width="130"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="specialty"
                align="center"
                :label="reviewType != '1009007002' ? '评标专业' : '评审专业'"
                min-width="130"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="ruleName"
                align="center"
                label="抽取条件"
                min-width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="isJoin"
                align="center"
                label="参评结果"
                min-width="130"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.isJoin ? "参加" : "不参加" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getExtractDetail } from "../../../../api/modules/projectManagement"

export default {
  name: "extract-results",
  props: {
    rowData: {
      type: Array
    },
    businessId: {
      type: String
    },
    reviewType: {
      type: [String, Number]
    }
  },
  watch: {
    reviewType: {
      immediate: true,
      handler(n, o) {
        if (n == "1009007002") {
          this.getExtractDetail()
        } else {
          this.isEmpty = this.rowData.length == 0
        }
      }
    }
  },
  // computed: {
  //   isEmpty() {
  //     if (this.reviewType == "1009007002") {
  //       console.log(this.extractDetailObj);
  //       return !(this.extractDetailObj.length == 0 && this.rowData.length == 0);
  //     } else {
  //       return this.extractDetailObj.length != 0;
  //     }
  //   }
  // },
  data() {
    return {
      activeNames: ["1"],
      extractDetailObj: [],
      isEmpty: false // 是否有数据
    }
  },
  methods: {
    getExtractDetail() {
      getExtractDetail({
        id: this.businessId,
        busType: this.reviewType
      }).then((res) => {
        if (res.operationCode == 1) {
          this.extractDetailObj = res.data.data.extractDetails
          this.isEmpty =
            this.extractDetailObj.length == 0 && this.rowData.length == 0
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-collapse-item__header {
  background: #eff6fe;
  font-weight: bolder;
  padding-left: 10px;
}

.zjxq_box {
  padding: 10px 20px;
  margin-bottom: 10px;

  .box_text {
    font-weight: 500;

    &:before {
      content: "";
      width: 3px;
      margin-right: 5px;
      height: 12px;
      background: #1f79ff;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .zjxq_box_item {
    display: inline-block;
    width: 300px;
    height: 40px;
    line-height: 40px;
    background: #f2f2f2;
    padding: 0 5px;
  }

  .box_item {
    width: 100%;
    background: #f8f8f8;
    padding: 15px 25px;
  }
}
</style>
